import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';

interface FormDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading?: boolean;
  showSubmitButton?: boolean;
}

export function FormDialog({
  isOpen,
  onClose,
  title,
  children,
  onSubmit,
  isLoading = false,
  showSubmitButton = true,
}: FormDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[800px] shadow-lg rounded-lg max-h-[90vh] flex flex-col p-6">
        <DialogHeader className="shrink-0">
          <DialogTitle className="text-xl font-bold text-gray-900">{title}</DialogTitle>
        </DialogHeader>
        <form onSubmit={onSubmit} className="flex flex-col flex-1 min-h-0 flex gap-4">
          <div className="space-y-4 [&_label]:text-base [&_label]:text-gray-700 [&_label]:font-medium [&_input]:text-base [&_input]:text-gray-900 [&_input]:bg-white [&_input]:border-gray-300 overflow-y-auto min-h-0 min-h-[12rem] max-h-[min(65vh,520px)] pr-2">
            {children}
          </div>
          {showSubmitButton && (
            <DialogFooter className="shrink-0 mt-4 pt-4 border-t border-gray-200">
              <Button type="button" variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit" disabled={isLoading}>
                {isLoading ? 'Saving...' : 'Save'}
              </Button>
            </DialogFooter>
          )}
        </form>
      </DialogContent>
    </Dialog>
  );
} 